import isOptInExperienceEnabledForPrioritize from 'owa-copilot-settings-utils/lib/utils/isOptInExperienceEnabledForPrioritize';
import isCopilotFeatureEnabled from 'owa-copilot-settings-utils/lib/utils/isCopilotFeatureEnabled';
import getModuleContextMailboxInfo from 'owa-module-context-mailboxinfo/lib/selectors/getModuleContextMailboxInfo';
import isPopout from 'owa-popout-v2/lib/utils/isPopout';
import getApplicationSettings from 'owa-application-settings/lib/selectors/getApplicationSettings';

export function shouldShowPrioritizeMenuItem(
    shouldIgnoreUserPreferences: boolean,
    targetWindow: Window
): boolean {
    const mailboxInfo = getModuleContextMailboxInfo();

    // https://ecs.skype.com/Substrate/OutlookWebClient/configurations/1092852
    const isOptInAvailable =
        getApplicationSettings('Copilot', mailboxInfo).prioritizeOptInEnabled &&
        isOptInExperienceEnabledForPrioritize(mailboxInfo);

    return (
        !isPopout(targetWindow) &&
        (isCopilotFeatureEnabled(
            'Inbox',
            mailboxInfo,
            true /* skipLanguageCheck */,
            shouldIgnoreUserPreferences
        ) ||
            isOptInAvailable)
    );
}
